angular.module('bmsApp.trugreen.schedule', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.trugreen.schedule', {
					url: '^/trugreen/schedule?date',
					views: {
						'main@main': {
							templateUrl: 'ng/trugreen/schedule/templates/Schedule.html',
							controller: 'TGScheduleCtrl'
						}
					},
					ncyBreadcrumb: { label: 'Schedule' }
				})

			;

		}]);
